// extracted by mini-css-extract-plugin
export default {"messageList":"messageList_messageList__efMPz"};